import React, { useEffect } from "react";
import { Form, Input, Select, InputNumber, Button, Space } from "antd";

const { Option } = Select;
const { TextArea } = Input;

const AlertRuleForm = ({ initialValues, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        channels: initialValues.channels ? JSON.parse(initialValues.channels) : [],
      });
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (err) {
      console.error("表单验证失败:", err);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{
        duration: 1,
        severity: "warning",
      }}
    >
      <Form.Item
        label="规则名称"
        name="name"
        rules={[{ required: true, message: "请输入规则名称" }]}
      >
        <Input placeholder="请输入规则名称" />
      </Form.Item>

      <Form.Item
        label="告警类型"
        name="type"
        rules={[{ required: true, message: "请选择告警类型" }]}
      >
        <Select placeholder="请选择告警类型">
          <Option value="trade_volume">交易量</Option>
          <Option value="balance">余额</Option>
          <Option value="pnl">盈亏</Option>
          <Option value="data_missing">数据缺失</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="检测指标"
        name="metric"
        rules={[{ required: true, message: "请输入检测指标" }]}
      >
        <Input placeholder="例如: volume_change_rate, balance_change" />
      </Form.Item>

      <Form.Item
        label="比较运算符"
        name="operator"
        rules={[{ required: true, message: "请选择比较运算符" }]}
      >
        <Select placeholder="请选择比较运算符">
          <Option value="gt">大于 (&gt;)</Option>
          <Option value="lt">小于 (&lt;)</Option>
          <Option value="eq">等于 (=)</Option>
          <Option value="change_rate">变化率</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="阈值"
        name="threshold"
        rules={[{ required: true, message: "请输入阈值" }]}
      >
        <InputNumber
          style={{ width: "100%" }}
          placeholder="请输入阈值"
          min={0}
        />
      </Form.Item>

      <Form.Item
        label="持续次数"
        name="duration"
        rules={[{ required: true, message: "请输入持续次数" }]}
      >
        <InputNumber
          style={{ width: "100%" }}
          placeholder="连续触发多少次后告警"
          min={1}
        />
      </Form.Item>

      <Form.Item
        label="严重程度"
        name="severity"
        rules={[{ required: true, message: "请选择严重程度" }]}
      >
        <Select placeholder="请选择严重程度">
          <Option value="critical">严重</Option>
          <Option value="warning">警告</Option>
          <Option value="info">信息</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="通知渠道"
        name="channels"
        rules={[{ required: true, message: "请选择至少一个通知渠道" }]}
      >
        <Select
          mode="multiple"
          placeholder="请选择通知渠道"
        >
          <Option value="feishu">飞书</Option>
          <Option value="email">邮件</Option>
          <Option value="webhook">Webhook</Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type="primary" onClick={handleSubmit}>
            提交
          </Button>
          <Button onClick={onCancel}>取消</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default AlertRuleForm;
